import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import axios from "axios";

const QuizSelectionModel  = ({ open, onClose, selectedRow }) => {
  const [catData, setCatData] = useState([]);
  const [subCatData, setSubCatData] = useState([]);
  const [quizData, setQuizData] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubcategory, setSelectedSubcategory] = useState("");
  const [selectedQuizId, setSelectedQuizId] = useState("");

  const [loading, setLoading] = useState(false);

  const appToken = localStorage.getItem("webtoken");
  const auth = "Bearer " + appToken;

  // ✅ Load categories when popup opens
  useEffect(() => {
    if (open) {
      setSelectedCategory("");
      setSelectedSubcategory("");
      setSelectedQuizId("");
      setCatData([]);
      setSubCatData([]);
      setQuizData([]);

      setLoading(true);
      axios
        .get("https://s3napi-dev.s3nsoftware.com/api/Categories", {
          headers: { Authorization: auth },
        })
        .then((res) => setCatData(res.data))
        .catch((err) => console.error("Error fetching categories", err))
        .finally(() => setLoading(false));
    }
  }, [open, auth]);

  // ✅ Load subcategories when category changes
  const handleCategoryChange = (e) => {
    const catId = e.target.value;
    setSelectedCategory(catId);
    setSelectedSubcategory("");
    setSelectedQuizId("");
    setSubCatData([]);
    setQuizData([]);

    setLoading(true);
    axios
      .get(
        `https://s3napi-dev.s3nsoftware.com/api/Categories/GetSubCategoriesByCatId?catId=${catId}`,
        { headers: { Authorization: auth } }
      )
      .then((res) => 
        setSubCatData(res.data))
      .catch((err) => console.error("Error fetching subcategories", err))
      .finally(() => setLoading(false));
  };

  // ✅ Load quizzes when subcategory changes
  const handleSubcategoryChange = (e) => {
    const subId = e.target.value;
    setSelectedSubcategory(subId);
    setSelectedQuizId("");
    setQuizData([]);

    setLoading(true);
    axios
      .get(
        `https://s3napi-dev.s3nsoftware.com/api/Quizzes/GetQuizzesBySubCategory?subCatId=${subId}`,
        { headers: { Authorization: auth } }
      )
      .then((res) => setQuizData(res.data))
      .catch((err) => console.error("Error fetching quizzes", err))
      .finally(() => setLoading(false));
  };


const Save = async ()  => {
    selectedRow.QuizId = selectedQuizId;
    const response = await axios.post(
        "https://s3napi-dev.s3nsoftware.com/api/WordOfTheDay/Update",
        selectedRow,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
    const modifiedField = await updateWord(selectedRow);
    onClose();
}


  const updateWord = async (updated_data) => {
    console.log("Sending new entry:", updated_data);
    const now = new Date().toISOString();

    const username = localStorage.getItem("username") || "UnknownUser";
    updated_data.Username = username;
     
    // Entry exists – check for field modifications

    for (const key in updated_data) {
      if (
        key !== "FirstInserted" &&
        key !== "LastUpdated" &&
        key !== "Multichoices" &&
        key === "QuizId" 
      ) {
        const modifiedField = {
          Id: updated_data.Id,
          Word: updated_data.Word,
          Username: updated_data.Username,
          FirstInserted: now,
          ModifiedValue: updated_data[key],
          ModifiedType: key,
          WordId: updated_data.Id,
        };

        console.log("Sending change:", modifiedField);

        try {
          const response = await fetch(
            "https://s3napi-dev.s3nsoftware.com/api/WordOfTheDay/UpdateWordlogs",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(modifiedField),
            }
          );

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const result = await response.json();

          console.log("Word log updated successfully:", result);
         // setupdatedValues(modifiedField);
          return modifiedField;
        } catch (error) {
          console.error("Error updating word log:", error);
        }

        return;
      }
    }

    console.log("No field was modified.");
  };


  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Select Quiz</DialogTitle>
      <DialogContent dividers>
        {loading && (
          <div style={{ textAlign: "center", margin: "10px 0" }}>
            <CircularProgress size={30} />
          </div>
        )}

        {selectedRow && (
          <div style={{ marginBottom: "15px" }}>
            <p>
              <strong>Word:</strong> {selectedRow.Word}
            </p>
          </div>
        )}

        {/* Category Dropdown */}
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>Category</InputLabel>
          <Select
            value={selectedCategory}
            label="Category"
            onChange={handleCategoryChange}
          >
            {catData.map((cat) => (
              <MenuItem key={cat.Id} value={cat.Id}>
                {cat.CategoryName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Subcategory Dropdown */}
        <FormControl
          fullWidth
          sx={{ mb: 2 }}
          disabled={!selectedCategory || subCatData.length === 0}
        >
          <InputLabel>Subcategory</InputLabel>
          <Select
            value={selectedSubcategory}
            label="Subcategory"
            onChange={handleSubcategoryChange}
          >
            {subCatData.map((sub) => (
              <MenuItem key={sub.Id} value={sub.Id}>
                                {sub.SubCategoryName || sub.SubCatName}

              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Quiz Dropdown */}
        <FormControl
          fullWidth
          sx={{ mb: 2 }}
          disabled={!selectedSubcategory || quizData.length === 0}
        >
          <InputLabel>Quiz</InputLabel>
          <Select
            value={selectedQuizId}
            label="Quiz"
            onChange={(e) => setSelectedQuizId(e.target.value)}
          >
            {quizData.map((quiz) => (
              <MenuItem key={quiz.Id} value={quiz.Id}>
                {quiz.QuizName} (ID: {quiz.Id})
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={() => {
            console.log("Selected Data:", {
              category: selectedCategory,
              subcategory: selectedSubcategory,
              quiz: selectedQuizId,
            });
            
            Save();
          }}
          disabled={!selectedQuizId}
          variant="contained"
          color="primary"
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QuizSelectionModel;
